import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { Customer } from '../customer';
import { CustomerTypeBuilder } from './customer-type-builder';

export class CustomerBuilder {

  static fromJson(json): Customer {
    return (json) ? new Customer(
      json.hash,
      json.businessName,
      json.tradeName,
      json.tin,
      json.address,
      json.deliveryAddress,
      json.postCode,
      json.city,
      json.province,
      json.country,
      json.email,
      json.phone,
      json.contactPerson,
      json.contactPerson2,
      json.vat,
      json.customerType ? CustomerTypeBuilder.fromJson(json.customerType) : null,
    ) : null;
  }

  static fromJsonList(list): Customer[] {
    return (isArray(list)) ? sortByString('businessName', mapCollection(CustomerBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/customer-builder.ts